import {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import { isAuthenticated, hasCompletedOnboarding } from '../utils/AuthorizationCheck';

const Settings = ({auth}) => {      
    
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [isPortalLoading, setIsPortalLoading] = useState(false);
    const history = useHistory();
    
    const getEmail = async () => {
        try {
            const userInfo = await axios.post('/api/post/fetch-user-info');
                    
            if ( userInfo.status === 200 ) {
                setEmail( userInfo.data.userInfo.email );
                setFirstName( userInfo.data.userInfo.first_name );
                setLastName( userInfo.data.userInfo.last_name );
            }
        } catch (error) {
            console.error('Error fetching user info:', error);
        }
    };
    
    // Authorization guard
    useEffect(() => {
        // Don't redirect until auth state is fully hydrated
        if (!auth.hydrated) {
            return;
        }
        
        if (!isAuthenticated(auth)) {
            history.push('/');
            return;
        }
        
        if (!hasCompletedOnboarding(auth)) {
            history.push('/onboarding/platform');
            return;
        }
        
        // User is authenticated and completed onboarding, load data
        getEmail();
    }, [auth, history]);

    function capitalizeFirstLetter(string) {
        return string === null ? null : string.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    function readableDate(dateTimestamp) {
        
        if ( dateTimestamp === null ) {
            return null;
        }
        const date = new Date(dateTimestamp);

        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        return formattedDate;
    }

    const handlePortalSubmit = async () => {
        setIsPortalLoading(true);
        
        try {
            // Create and submit form programmatically
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/post/stripe/create-portal-session';
            
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'customer_id';
            input.value = auth.user?.permission?.stripe_customer_id;
            
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
        } catch (error) {
            console.error('Error submitting portal form:', error);
            setIsPortalLoading(false);
        }
    };

    // Don't render until auth check is complete and hydrated
    if (!auth.hydrated || !isAuthenticated(auth) || !hasCompletedOnboarding(auth)) {
        return null;
    }

    return (

        <>
            <div className="pt-5">    
                <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                    <Col xs={1}></Col>
                    <Col xs={10}>       
                            
                        {/* Page Header */}
                        <Row style={{ marginBottom: "32px" }}>
                            <Col xs={12}>
                                <h1 style={{ 
                                    color: "#FFFFFF", 
                                    fontSize: "28px", 
                                    fontWeight: "700",
                                    margin: 0
                                }}>
                                    ⚙️ SETTINGS
                                </h1>
                            </Col>
                        </Row>
                        {/* Contact Information Card */}
                        <Row style={{ marginBottom: "24px" }}>
                            <Col xs={12}>
                                <Card style={{
                                    background: "rgba(30, 41, 59, 0.95)",
                                    backdropFilter: "blur(20px)",
                                    border: "1px solid rgba(255, 255, 255, 0.4)",
                                    borderRadius: "16px",
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                }}>
                                    <Card.Body style={{ padding: "24px" }}>
                                        <h2 style={{
                                            color: "#FFFFFF",
                                            fontSize: "20px",
                                            fontWeight: "600",
                                            marginBottom: "20px"
                                        }}>
                                            👤 USER
                                        </h2>
                                        
                                        <Row style={{ marginBottom: "16px" }}>
                                            <Col xs={6} md={2}>
                                                <span style={{
                                                    color: "#E0E0E0",
                                                    fontSize: "16px",
                                                    fontWeight: "500"
                                                }}>
                                                    Name
                                                </span>
                                            </Col>
                                            <Col xs={6} md={4}>
                                                <span style={{
                                                    color: "#FFFFFF",
                                                    fontSize: "16px"
                                                }}>
                                                    {firstName} {lastName}
                                                </span>
                                            </Col>
                                        </Row>
                                        
                                        <Row>
                                            <Col xs={6} md={2}>
                                                <span style={{
                                                    color: "#E0E0E0",
                                                    fontSize: "16px",
                                                    fontWeight: "500"
                                                }}>
                                                    Email
                                                </span>
                                            </Col>
                                            <Col xs={6} md={6}>
                                                <span style={{
                                                    color: "#FFFFFF",
                                                    fontSize: "16px"
                                                }}>
                                                    {email}
                                                </span>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Subscription Information Card */}
                        {auth.user?.permission?.stripe_customer_id !== null ? (
                            <Row style={{ marginBottom: "24px" }}>
                                <Col xs={12}>
                                    <Card style={{
                                        background: "rgba(30, 41, 59, 0.95)",
                                        backdropFilter: "blur(20px)",
                                        border: "1px solid rgba(255, 255, 255, 0.4)",
                                        borderRadius: "16px",
                                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                    }}>
                                        <Card.Body style={{ padding: "24px" }}>
                                            <h2 style={{
                                                color: "#FFFFFF",
                                                fontSize: "20px",
                                                fontWeight: "600",
                                                marginBottom: "20px"
                                            }}>
                                                🔄 SUBSCRIPTION
                                            </h2>
                                            
                                            <Row style={{ marginBottom: "16px" }}>
                                                <Col xs={6} md={2}>
                                                    <span style={{
                                                        color: "#E0E0E0",
                                                        fontSize: "16px",
                                                        fontWeight: "500"
                                                    }}>
                                                        Tier
                                                    </span>
                                                </Col>
                                                <Col xs={6} md={4}>
                                                    <span style={{
                                                        color: "#FFFFFF",
                                                        fontSize: "16px"
                                                    }}>
                                                        {capitalizeFirstLetter(auth.user?.permission?.tier)}
                                                    </span>
                                                </Col>
                                            </Row>
                                            
                                            <Row style={{ marginBottom: "16px" }}>
                                                <Col xs={6} md={2}>
                                                    <span style={{
                                                        color: "#E0E0E0",
                                                        fontSize: "16px",
                                                        fontWeight: "500"
                                                    }}>
                                                        Length
                                                    </span>
                                                </Col>
                                                <Col xs={6} md={4}>
                                                    <span style={{
                                                        color: "#FFFFFF",
                                                        fontSize: "16px"
                                                    }}>
                                                        {capitalizeFirstLetter(auth.user?.permission?.interval)}
                                                    </span>
                                                </Col>
                                            </Row>
                                            
                                            <Row>
                                                <Col xs={6} md={2}>
                                                    <span style={{
                                                        color: "#E0E0E0",
                                                        fontSize: "16px",
                                                        fontWeight: "500"
                                                    }}>
                                                        Renewal Date
                                                    </span>
                                                </Col>
                                                <Col xs={6} md={4}>
                                                    <span style={{
                                                        color: "#FFFFFF",
                                                        fontSize: "16px"
                                                    }}>
                                                        {readableDate(auth.user?.permission?.subscription_current_period_end)}
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        ) : (
                            <Row style={{ marginBottom: "24px" }}>
                                <Col xs={12}>
                                    <Card style={{
                                        background: "rgba(30, 41, 59, 0.95)",
                                        backdropFilter: "blur(20px)",
                                        border: "1px solid rgba(255, 255, 255, 0.4)",
                                        borderRadius: "16px",
                                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                    }}>
                                        <Card.Body style={{ padding: "24px" }}>
                                            <h2 style={{
                                                color: "#FFFFFF",
                                                fontSize: "20px",
                                                fontWeight: "600",
                                                marginBottom: "20px"
                                            }}>
                                                🔄 SUBSCRIPTION
                                            </h2>
                                            <p style={{
                                                color: "#E0E0E0",
                                                fontSize: "16px",
                                                fontStyle: "italic",
                                                margin: 0
                                            }}>
                                                No subscription information available
                                            </p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                        {/* Payment Management Card */}
                        {auth.user?.permission?.stripe_customer_id !== null && (
                            <Row>
                                <Col xs={12}>
                                    <Card style={{
                                        background: "rgba(30, 41, 59, 0.95)",
                                        backdropFilter: "blur(20px)",
                                        border: "1px solid rgba(255, 255, 255, 0.4)",
                                        borderRadius: "16px",
                                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                    }}>
                                        <Card.Body style={{ padding: "24px" }}>
                                            <h2 style={{
                                                color: "#FFFFFF",
                                                fontSize: "20px",
                                                fontWeight: "600",
                                                marginBottom: "16px"
                                            }}>
                                                💳 PAYMENT
                                            </h2>
                                            <p style={{
                                                color: "#E0E0E0",
                                                fontSize: "14px",
                                                marginBottom: "20px",
                                                fontStyle: "italic"
                                            }}>
                                                You must use the Stripe portal to cancel your subscription.
                                            </p>
                                            <button 
                                                id="checkout-and-portal-button" 
                                                type="button" 
                                                className="btn btn-lg" 
                                                style={{
                                                    backgroundColor: "#5865F2",
                                                    borderColor: "#5865F2",
                                                    color: "#FFFFFF",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    padding: "12px 24px",
                                                    borderRadius: "8px",
                                                    border: "none",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onClick={handlePortalSubmit}
                                                disabled={isPortalLoading}
                                                onMouseEnter={(e) => {
                                                    if (!isPortalLoading) {
                                                        e.target.style.backgroundColor = "#4752C4";
                                                        e.target.style.transform = "translateY(-1px)";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isPortalLoading) {
                                                        e.target.style.backgroundColor = "#5865F2";
                                                        e.target.style.transform = "translateY(0)";
                                                    }
                                                }}
                                            >
                                                {isPortalLoading ? (
                                                    <>
                                                        <div className="spinner-border spinner-border-sm me-2" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                        Processing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-credit-card me-2"></i>
                                                        Stripe Customer Portal
                                                    </>
                                                )}
                                            </button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                        
                    </Col>                            
                </Row>
            </div>
        </>
    );
};


function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Settings);
